import { useState } from "react";
import { AdPlanContext } from "./AdPlanContext";

const AdPlanProvider = ({ children }) => {
  const [parentPlan, setParentPlan] = useState();
  const [childPlan, setChildPlan] = useState();
  const [savedChildPlans, setSavedChildPlans] = useState([]);
  const [childComponentsCompleted, setChildComponentsCompleted] = useState(false);
  const [refetchOnUpdate, setRefetchOnUpdate] = useState(false);

  const resetAdPlanContext = () => {
    setParentPlan(null);
    setChildPlan(null);
    setSavedChildPlans(null);
    setChildComponentsCompleted(false);
  };

  const removeChildPlan = () => {
    setChildPlan(null);
  };

  return (
    <AdPlanContext.Provider
      // oxlint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        parentPlan,
        setParentPlan,
        childPlan,
        setChildPlan,
        removeChildPlan,
        savedChildPlans,
        setSavedChildPlans,
        childComponentsCompleted,
        setChildComponentsCompleted,
        resetAdPlanContext,
        refetchOnUpdate,
        setRefetchOnUpdate,
      }}
    >
      {children}
    </AdPlanContext.Provider>
  );
};

export default AdPlanProvider;
